class AiRangeProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");
    this.button = this.querySelector('[name="add"]');
    if (!this.form || !this.button) return;
    this.defaultText = this.button.textContent.trim();
    this.addedText = this.button.dataset.addedText || "Added ✓";
    this.form.addEventListener("submit", this.onSubmit.bind(this));
  }

  onSubmit(evt) {
    evt.preventDefault();
    if (this.button.disabled) return;
    this.button.disabled = true;

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    config.body = new FormData(this.form);

    fetch(window.MinimogSettings.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.button.disabled = false;
          window.MinimogTheme.Notification.show({
            target: document.body,
            method: "appendChild",
            type: "error",
            message: response.message,
            last: 3000,
            sticky: true,
          });
          return;
        }

        fetchJSON(window.Shopify.routes.root + "cart.json").then((cart) => {
          document.querySelectorAll(".m-cart-count-bubble").forEach((cartCount) => {
            if (cart.item_count > 0) {
              cartCount.textContent = cart.item_count;
              cartCount.classList.remove("m:hidden");
            } else {
              cartCount.classList.add("m:hidden");
            }
          });
        });

        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: "ai-range-product-form" });

        this.button.textContent = this.addedText;
        this.button.classList.add("is-added");
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.button.textContent = this.defaultText;
          this.button.classList.remove("is-added");
          this.button.disabled = false;
        }, 1800);
      })
      .catch(() => {
        this.button.disabled = false;
      });
  }
}

customElements.define("ai-range-product-form", AiRangeProductForm);
